import * as React from 'react';
import { Spinner } from 'components/Spinner';
import { prerenderedLoadable } from 'utils/prefetch';
const SitemapPage = prerenderedLoadable(() => import(/* webpackChunkName: "Sitemap" */ 'containers/Content/Sitemap/Sitemap'));
export const Sitemap = () => (React.createElement(React.Suspense, { fallback: React.createElement(Spinner, null) },
    React.createElement(SitemapPage, null)));
